export var AssetsList = [
    // "AAVE",
    // "WAVAX",
    // "sAVAX",
    "WETH",
    "ETH",
    // "USDC",
    // "USDC.e",
    // "WBTC",
    // "stETH",
    // "wstETH",
    // "yvUSDC",
    // "PERP",
    // "RBN",
    // "veRBN",
    // "LDO",
    // "SOL",
    // "APE",
    // "WBNB",
    // "WHT",
    // "BUSD",
    "WBTC",
    "USDC",
    "WBNB",
    "BNB"
];
export var WalletsList = [
    "Metamask",
    "WalletConnect",
    "WalletLink",
    "Phantom",
    "Solflare",
];
export var GovernanceStakeTransactions = [
    "governanceStake",
    "governanceIncreaseAmount",
    "governanceIncreaseDuration",
];
export var GovernanceApproveUnstakeTransactions = [
    "governanceApproval",
    "governanceUnstake",
];
//# sourceMappingURL=types.js.map